module.exports = __webpack_public_path__ + "static/media/helexia_chosen_icon.2c1110ad.svg";